import { createAction, props } from '@ngrx/store';


export const loadInactivePrograms = createAction(
  '[Programs-List] Load Inactive Programs',
);

export const loadInactiveProgramsSuccess = createAction(
  '[Programs-List] Load Inactive Programs Success',
   props<{ data: string[] }>(),
);

export const loadInactiveProgramsFailure = createAction(
  '[[Programs-List] Load Inactive Programs Failure',
  props<{ error: any }>(),
);
